export default __webpack_public_path__ + "static/media/Real-estate.85ac80f9.png";